import { useTranslation } from "react-i18next";

import { ReturnRow } from "../../models/returns/IReturnsApi";
import { reasonGroupLabel, reasonLabel } from "../../utils/returnsRules";

type ReasonCellProps = Pick<ReturnRow, "reason" | "reasonLabel" | "reasonGroup" | "reasonDetail" | "loggedBy" | "loggedVia" | "ebayReturnId">;

/** eBay's reason with its group under it, or who logged a manual return and how. */
export default function ReasonCell({ reason, reasonLabel: label, reasonGroup, reasonDetail, loggedBy, loggedVia, ebayReturnId }: ReasonCellProps) {
  const { t } = useTranslation("returns");
  const second = !ebayReturnId && loggedBy ? t("Logged by {{who}} · {{via}}", { who: loggedBy, via: loggedVia ?? t("desktop") }) : reasonDetail || reasonGroupLabel(reasonGroup);
  return (
    <div className="flex flex-col">
      <span className="text-gray-900">{label || reasonLabel(reason)}</span>
      <span className="text-[11px] text-gray-500">{second}</span>
    </div>
  );
}
